import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetPointCentralStatusRequest = {
  buildingId: number
}

type PointCentralStatus = {
  isConnected: boolean
}

export const getPointCentralStatusQueryKey = (data: GetPointCentralStatusRequest) => [
  'useGetPointCentralStatus',
  data,
]

const getPointCentralStatus = async (data: GetPointCentralStatusRequest) => {
  const response = await authAPI.get<PointCentralStatus>(
    `/building/${data.buildingId}/point-central/integration`,
  )
  return response.data
}

export const useGetPointCentralStatus = (data: GetPointCentralStatusRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getPointCentralStatus(data),
    queryKey: getPointCentralStatusQueryKey(data),
  })
